import { render, staticRenderFns } from "./ConfirmApproveModal.vue?vue&type=template&id=abe4606e&scoped=true"
import script from "./ConfirmApproveModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmApproveModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmApproveModal.vue?vue&type=style&index=0&id=abe4606e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe4606e",
  null
  
)

export default component.exports